import { FTScroll } from "./ftScroller";
import { mobileOrNot } from "./mobileDetect";
import imagesLoaded from "imagesloaded";
import PerfectScrollbar from 'perfect-scrollbar';
// This file consists of all tricks and quirks we need to get along with iOS browsers
const iOS_1to12 = /iPad|iPhone|iPod/.test(navigator.platform);

const iOS13_iPad =
  navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

const iOS1to12quirk = function () {
  var audio = new Audio(); // temporary Audio object
  audio.volume = 0.5; // has no effect on iOS <= 12
  return audio.volume === 1;
};

//const isIOS = !window.MSStream && (iOS_1to12 || iOS13_iPad || iOS1to12quirk());
const isIOS = false;
export const disableiOSRubberScroll = () => {

  if (!isIOS) return;
  document.body.addEventListener(
    "touchmove",
    function (event) {
      event.preventDefault();
    },
    {
      passive: false,
      useCapture: false,
    }
  );
};


export const addMarginIfiOSAddressBar = (engine) => {
  if (!isIOS || !mobileOrNot() || $(window).width() < $(window).height()) return;


  const diff = screen.width - window.innerHeight;
  if (diff > 30) {
    document.body.style.marginTop = diff + "px";
    engine.resize();
  } else {
    document.body.style.marginTop = 0 + "px";
    engine.resize();
  }
};

export const iOSallowScroll = (query, options) => {
  if(!isIOS || !mobileOrNot()) return null;

  window.FTScroll = FTScroll


	if(!options) options = {
		scrollingX: false, 
		alwaysScroll: true,
    bouncing: false,
		updateOnWindowResize: true
  }

  const scroller = FTScroll(document.querySelector(query), options);
  if(query === "#twitter") {
    window.twitterScroller = scroller;
  }

    
  imagesLoaded(query, function () {
    console.log(`client height when images loaded ` + document.querySelector(query).clientHeight)
    scroller.updateDimensions();
  });

	return scroller 
}